import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { matchPath, useNavigate } from 'react-router-dom';
import { themeProvider } from '../../themeProvider';
import styles from '../../styles/typography.module.css';
import UpgradeYourPlan from './UpgradeYourPlan';
import { Routes } from '../../constants/pages';
import { SegmentService } from '../../services/helpers/segment';

interface Props {
  redirectedFromPage: string;
}

const UpgradeYourPlanPage: React.FC<Props> = (props) => {
  const { redirectedFromPage } = props;
  const navigate = useNavigate();
  const [subtitle, setSubtitle] = useState('');
  const [descriptionTitle, setDescriptionTitle] = useState('');
  const [bullets, setBullets] = useState<string[]>([]);

  useEffect(() => {
    SegmentService.trackEventNoSlack('missing-permission', {
      onPage: redirectedFromPage,
    });

    if (matchPath(Routes.ContainerTracking, redirectedFromPage)) {
      setSubtitle('Upgrade your plan to start tracking your containers at the port!');
      setDescriptionTitle('Improve your operations by tracking your containers at the terminal:');
      setBullets([
        'Track your import containers pickup availability;',
        'Track your empty containers appointments availabilities;',
        'Prioritize your containers by last free day to reduce Demurrage and Per Diem Fees.',
      ]);
    } else if (
      matchPath(Routes.TerminalScreenshots, redirectedFromPage) ||
      matchPath(Routes.RegionalTerminalScreenshots, redirectedFromPage) ||
      matchPath(Routes.PerDiemFighter, redirectedFromPage) ||
      matchPath(Routes.RegionalPerDiemArchive, redirectedFromPage)
    ) {
      setSubtitle(
        'Upgrade your plan to gain access to two years of terminal data, with automated reports to help you fight and prevent per diem fees!'
      );
      setDescriptionTitle('Reduce your per diem fees with the Per Diem Fighter plan:');
      setBullets([
        'Build your documentation to provide proof for your per diem claims;',
        'Download, receive or send by email automated screenshots of terminal return instructions when no appointment is available;',
        'Download, receive or send by email automated screenshots of terminal return instructions from the past.',
      ]);
    } else if (
      matchPath(Routes.EmptyAppointments, redirectedFromPage) ||
      matchPath(Routes.RegionalEmptyAppointments, redirectedFromPage)
    ) {
      setSubtitle('Upgrade your plan to secure empty return appointments!');
      setDescriptionTitle(
        'Return your empties on time with the Dispatcher Shop or Per Diem Fighter plans:'
      );
      setBullets([
        'Search appointments by shipping line and container size;',
        'Get real-time empty appointments availabilities for the 12 terminals of LA/LB;',
        'Click the terminal link to be redirected to the terminal websites and proceed with your bookings.',
      ]);
    }
  }, [redirectedFromPage]);

  const redirectToPricing = () => {
    navigate(Routes.Plans);
  };

  return (
    <ThemeProvider theme={themeProvider}>
      <div className={styles.font}>
        <UpgradeYourPlan
          handleUpgradeClick={redirectToPricing}
          subtitle={subtitle}
          descriptionTitle={descriptionTitle}
          bullets={bullets}
        />
      </div>
    </ThemeProvider>
  );
};

export default UpgradeYourPlanPage;
